package com.maximdvinov.ui

import org.jetbrains.compose.web.css.Color

object PortfolioColors {
    val Ink = Color("#122015")
    val Muted = Color("#5f6f61")
    val Paper = Color("#f3f8ee")
    val Panel = Color("#d8ecd7")
    val PanelSoft = Color("#e6f2e4")
    val Forest = Color("#2f6f41")
    val ForestDark = Color("#174c27")
    val Mint = Color("#cfe8cf")
    val Lime = Color("#d8f2ba")
    val Blue = Color("#d7e9f7")
    val Rose = Color("#f0d8df")
    val White = Color("#ffffff")
}

val coreTechnologies = listOf(
    "Kotlin",
    "Kotlin Multiplatform",
    "Jetpack Compose",
    "Compose Multiplatform",
    "Android",
    "Ktor",
    "Koin",
    "Hilt",
    "Kobweb",
    "SQLDelight",
    "Room",
    "Coroutines",
    "Git / GitHub",
)
